import React from 'react';
import { getUserTypeFromToken } from '../utils/TokenUtils';
import {
  canCreateViolation,
  canCreateWorkOrder,
  canManageReservations,
} from '../constants/UserTypes';
import { ReservationPrefill } from '../reservation/CreateReservationModal';
import { CreateButton } from './CreateButton';
import { useCommandPalette } from './CommandPaletteProvider';
import { CreateScope } from './createScope';

/**
 * A record page's create buttons, in its header strip: a new violation,
 * work order or reservation for what the page is about. The page's scope
 * goes in locked, so the modal opens filled in and its pickers offer only
 * what belongs here — the association's homes on an HOA, the member's
 * homes on a member, the vendor on a vendor. What was made is then
 * opened, as from the sidebar or ⌘K.
 *
 * Each button shows only to someone who may create that record.
 */
interface Props {
  scope: CreateScope;
  violation?: boolean;
  workOrder?: boolean;
  /** `true`, or where to start the booking (an amenity's own page). */
  reservation?: boolean | ReservationPrefill;
}

export const CreateActions: React.FC<Props> = ({
  scope,
  violation,
  workOrder,
  reservation,
}) => {
  const { openNewViolation, openNewWorkOrder, openNewReservation } =
    useCommandPalette();
  const userType = getUserTypeFromToken();
  const opts = { scope, lockScope: true };

  return (
    <>
      {violation && canCreateViolation(userType) && (
        <CreateButton
          variant="secondary"
          label="New violation"
          onClick={() => openNewViolation(opts)}
        />
      )}
      {workOrder && canCreateWorkOrder(userType) && (
        <CreateButton
          variant="secondary"
          label="New work order"
          onClick={() => openNewWorkOrder(opts)}
        />
      )}
      {reservation && canManageReservations(userType) && (
        <CreateButton
          variant="secondary"
          label="New reservation"
          onClick={() =>
            openNewReservation({
              ...opts,
              ...(reservation === true ? {} : { prefill: reservation }),
            })
          }
        />
      )}
    </>
  );
};
